import styled from 'styled-components';

export const PriceUnit = styled.span`
  font-size: 10px;
  color: #666;
`;
